import request from './request'
import type { ApiResponse } from './types'
/**
 * 获取 HTTP code 字典
 */
export function appConfigsCodesApi(data: {
  ver: string
}): Promise<ApiResponse<{ codes: Array<{ code: string; cn: string }>; ver: string }>> {
  return request.get('/app/configs/codes', { params: data })
}

/** 获取分享配置信息 */
export function appConfigsShareApi(): Promise<ApiResponse<{ qr_code: string; landing_url: string;  }>> {
  return request.get('/app/configs/share')
}

/** 获取 USDT 买 KB 汇率 */
export function appConfigsUsdtBuyKbRateApi(): Promise<ApiResponse<{ rate: number, min: number }>> {
  return request.get('/deposit/usdt/preflight')
}

/** USDT 充值确认 */
export function appConfigsUsdtBuyKbConfirmApi(data: { rate: number, usdt: number }): 
Promise<ApiResponse<{ address: string }>> {
  return request.post('/deposit/usdt/confirm', data)
}